var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['gavatar', { 'gavatar-sm': _vm.size === 'sm', 'gavatar-outlined': _vm.outlined }],style:(_vm.outlined ? { 'border-color': _vm.color } : { 'background-color': _vm.color }),attrs:{"title":_vm.title || _vm.name}},[_vm._v(" "+_vm._s(_vm.initials)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }